module.exports = __webpack_public_path__ + "img/client-8.37a0a952.png";